import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-praesenz',
  templateUrl: './praesenz.component.html',
  styleUrls: ['./praesenz.component.css']
})
export class PraesenzComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
